exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scrollable_box__wrap[data-v-775927e5]{overflow:auto;height:calc(100vh - 378px);width:100%}.scrollable_box__wrap[data-v-775927e5]::-webkit-scrollbar-track{-webkit-box-shadow:inset 0 0 6px rgba(0,0,0,.3);background-color:#f5f5f5}.scrollable_box__wrap[data-v-775927e5]::-webkit-scrollbar{width:6px;background-color:#f5f5f5}.scrollable_box__wrap[data-v-775927e5]::-webkit-scrollbar-thumb{background-color:#000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/less-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./modules/Home/views/src/components/Settings/BoxSearch.vue?vue&type=style&index=0&id=775927e5&scoped=true&lang=less&
// module id = 935
// module chunks = 0